import { SendIcon } from './SendIcon';

/**
 * author: Google
 * id 6791A1E4-DBF8-471C-AA27-0D4540A23678
 * name send
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send.svg
 * tags
 */
export const PaperAirplaneIcon = SendIcon;
export default PaperAirplaneIcon